import React, { useMemo } from 'react';
import classNames from 'classnames';
import { DealOutcome } from 'models/DealRoom';
import { Link } from 'react-router-dom';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';
import { useTranslation } from 'react-i18next';
import { Industry } from 'models/Industry';
import { getDataRoomRoute } from 'utils';
import { DATA_ROOM_LOGIN_SOURCE } from 'models/DataRoomLoginSource';
import BlankDocumentIcon from 'icons/BlankDocument.icon';

import './DataRoomInvitationCard.styles.scss';
import './DataRoomInvitationCard.styles.responsive.scss';

type DataRoomInvitationCardProps = {
  className?: string;
  dataRoomId: string;
  title: string;
  dealOutcome: DealOutcome;
  otherDealOutcome: string;
  industry: Industry;
  imageSrc: string;
};

const DataRoomInvitationCard: React.FC<DataRoomInvitationCardProps> = (
  props,
) => {
  const {
    className,
    imageSrc,
    dataRoomId,
    title,
    dealOutcome,
    otherDealOutcome,
    industry,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('data-room-invitation-card', className);

  const rerouteLink = useMemo(
    () => getDataRoomRoute(dataRoomId, undefined, DATA_ROOM_LOGIN_SOURCE.PORTFOLIO),
    [dataRoomId],
  );

  return (
    <div className={classes}>
      <div className="data-room-invitation-card__left">
        <div className="data-room-invitation-card__left__heading">
          <Link
            to={rerouteLink}
            className="data-room-invitation-card__left__heading__title"
          >
            {title}
          </Link>
          <Link
            to={rerouteLink}
            className="data-room-invitation-card__left__heading__deal-info"
          >
            <span>
              {dealOutcome === 'other' ? otherDealOutcome : t(dealOutcome)}
            </span>
            <span>{industry}</span>
          </Link>
        </div>

        <div className="data-room-invitation-card__left__actions">
          <Link to={rerouteLink} className="border">
            <BlankDocumentIcon />
            {t('manageDocuments')}
          </Link>
        </div>
      </div>

      <div className="data-room-invitation-card__image-container">
        <Link aria-label="Business details page" to={rerouteLink}>
          <ResolveImage
            alt="Listing"
            src={getImgUrl(imageSrc, RESIZED_WIDTH[480])}
          />
        </Link>
      </div>
    </div>
  );
};

export default DataRoomInvitationCard;
